<label class="label" *ngIf="label">
    {{ label }}
</label>
<div class="icons">
    <div class="icon ok"
         [class.active]="isChecked"
         [class.disabled]="disabled"
         (click)="onOkClick($event)">
        <span class="mark"></span>
    </div>
    <div class="icon nok"
         [class.active]="isUnchecked"
         [class.disabled]="disabled"
         (click)="onNokClick($event)">
        <span class="mark"></span>
    </div>
</div>
<span class="text">
    <ng-content></ng-content>
</span>
